<div class="clr-footer" *ngIf="showFooter" style="z-index: 1000">
  <div class="clr-row">
    <div class="clr-col" style="justify-content: flex-start">version: 1.2.3</div>
    <div class="clr-col">
      <span>{{ state }}</span>
    </div>
    <div class="clr-col" style="justify-content: flex-end">
      &copy; 2025 iaxus.com
    </div>
  </div>
</div>